export const isAndroid = (location.hostname || 'localhost' == 'localhost') && navigator.userAgent.indexOf('Android') >= 0;

export const isIOS = (location.hostname || 'localhost' == 'localhost') && navigator.userAgent.indexOf('iOS') >= 0;

export const isCordova = window.cordova != undefined;

export const isMobile = isCordova; //&& (((location.hostname || 'localhost' == 'localhost') && navigator.userAgentData?.mobile) || isAndroid || isIOS);

export default isAndroid;
